<template>
  <div>
    <div class="flex flex-wrap gap-1.5">
      <span
        v-for="(item, i) in items"
        :key="i"
        class="inline-flex items-center gap-1 bg-gray-100 text-gray-700 rounded px-2 py-0.5 text-xs font-mono"
      >
        {{ item }}
        <button
          v-if="editable"
          class="text-gray-400 hover:text-red-500"
          @click="remove(i)"
        >×</button>
      </span>
      <span v-if="!items.length && !editable" class="text-xs text-gray-400">{{ emptyText }}</span>
    </div>
    <div v-if="editable" class="flex items-center gap-1.5 mt-1.5">
      <input
        v-model.trim="draft"
        type="text"
        :placeholder="placeholder"
        class="border border-gray-200 rounded px-2 py-1 text-xs w-52 focus:outline-none focus:border-gray-400"
        @keyup.enter="add"
      />
      <button
        class="text-xs px-2 py-1 rounded border border-gray-200 text-gray-600 hover:border-gray-400"
        @click="add"
      >
        Add
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'StringListEditor',
  props: {
    items: { type: Array, required: true },
    editable: { type: Boolean, default: false },
    placeholder: { type: String, default: '' },
    emptyText: { type: String, default: 'None.' },
  },
  emits: ['update'],
  data() {
    return { draft: '' };
  },
  methods: {
    add() {
      if (!this.draft || this.items.includes(this.draft)) return;
      this.$emit('update', [...this.items, this.draft]);
      this.draft = '';
    },
    remove(index) {
      this.$emit('update', this.items.filter((_, i) => i !== index));
    },
  },
};
</script>
